const HUBSPOT_FORM_ID_MATCHER = /^hsForm/;

const isHubspotForm = form => {
  if (!(form instanceof HTMLFormElement)) return false;

  return Boolean(form.id.match(HUBSPOT_FORM_ID_MATCHER));
};

export default isHubspotForm;
